"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScrollingTextLine = exports.ScrollingText = void 0;
var scrolling_text_1 = require("./scrolling-text");
Object.defineProperty(exports, "ScrollingText", { enumerable: true, get: function () { return scrolling_text_1.ScrollingText; } });
var scrolling_text_line_1 = require("./scrolling-text-line");
Object.defineProperty(exports, "ScrollingTextLine", { enumerable: true, get: function () { return scrolling_text_line_1.ScrollingTextLine; } });
